import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Input, Select, Textarea, Button } from '../../../../../components/base/index';
import { Link } from 'react-router-dom';

export default class CetakSlipForm extends Component {
    constructor(props) {
        super(props);
       
        this._onDeleteList = this._onDeleteList.bind(this);
        this._onFormChange = this._onFormChange.bind(this);
      }
    _onDeleteList() {
        const { onDeleteList, fieldName } = this.props;
        
      }

      _onFormChange(event) {
        const { onChange } = this.props;
        onChange(event);
      }

render(){
    const {
        list, error, onChange,
        fieldName, plafond_name,onFormChange, form
      } = this.props;
  

  return (
    <div className="laporan-keu__content">
        <div className="komposisi-siswa__custom-form">
            <div className="laporan-keu__custom-form-row">
                <div className="laporan-keu__custom-form-row__field">
                    <Select
                    name="namaSaudara1"
                    label="Jenis Invoice"
                    onChange={onFormChange}
                    data={ '7A', '2019-2020'}
                    placeholder={''}
                    
                    // error={form.error.namaSaudara1 || ''}
                    />
                </div>
                <div className="laporan-keu__custom-form-column__field">
                    <Select
                    name="tahunajaran"
                    label="Tahun Ajaran"
                    onChange={onFormChange}
                    // value={form.value.tempatLahirSaudara1 || ''}
                    // error={form.error.tempatLahirSaudara1 || ''}
                    placeholder={'Pilihan'}
                    />
                </div>
            </div>
            <div className="laporan-keu__custom-form-row">
                <div className="laporan-keu__custom-form-row__field">
                    <Select
                    name="namaSaudara1"
                    label="Kelas"
                    onChange={onFormChange}
                    data={ '7A', '2019-2020'}
                    placeholder={''}
                    
                    // error={form.error.namaSaudara1 || ''}
                    />
                </div>
                <div className="laporan-keu__custom-form-column__field">
                    <Select
                    name="tahunajaran"
                    label="Bentuk"
                    onChange={onFormChange}
                    // value={form.value.tempatLahirSaudara1 || ''}
                    // error={form.error.tempatLahirSaudara1 || ''}
                    placeholder={'Pilihan'}
                    />
                </div>
            </div>
            <div className="laporan-keu__custom-form-row">
                <div className="laporan-keu__custom-form-row__field">
                    <Select
                    name="namaSaudara1"
                    label="Invoice"
                    onChange={onFormChange}
                    data={ '7A', '2019-2020'}
                    placeholder={''}
                    
                    // error={form.error.namaSaudara1 || ''}
                    />
                </div>
                <div className="laporan-keu__custom-form-column__field">
                    <Select
                    name="tahunajaran"
                    label="Biodata Siswa"
                    onChange={onFormChange}
                    // value={form.value.tempatLahirSaudara1 || ''}
                    // error={form.error.tempatLahirSaudara1 || ''}
                    placeholder={'Pilihan'}
                    />
                </div>
            </div>
            <div className="laporan-keu__custom-form-row">
                <div className="laporan-keu__custom-form-row__field">
                    <Input
                    type="date"
                    name="namaSaudara1"
                    label="Tanggal Slip"
                    onChange={onFormChange}
                    data={ '7A', '2019-2020'}
                    placeholder={''}
                    
                    // error={form.error.namaSaudara1 || ''}
                    />
                </div>
                <div className="laporan-keu__custom-form-column__field">
                    <Input 
                    type="text"
                    name="tahunajaran"
                    label="Nama Siswa/NIS"
                    onChange={onFormChange}
                    // value={form.value.tempatLahirSaudara1 || ''}
                    // error={form.error.tempatLahirSaudara1 || ''}
                    placeholder={'Pilihan'}
                    />
                </div>
            </div>
        </div>      
     </div>
  );
     }
}
CetakSlipForm.propTypes = {
  onFormChange: PropTypes.func,
  form: PropTypes.object.isRequired,
};
CetakSlipForm.defaultProps = {
  onFormChange: noop,
};
